export const LEAD_FORM_SENSITIVE_FIELDS = ['name']

export const ENRICH_CUSTOMER_SENSITIVE_FIELDS = [
  'results.propertyData.addressLine1',
  'results.propertyData.formattedAddress',
  'results.propertyData.id',
  'results.propertyData.legalDescription',
]
